import { Input } from './input.js';

const resetStyles = {
  fontFamily: "inherit",
  margin: 0,
  resize: "vertical",
  color: "inherit",
  overflow: "auto"
};
let Textarea = {
  baseStyle: {
    ...resetStyles,
    ...Input.baseStyle?.field,
    fontSize: "text-sm",
    lineHeight: "1.25rem"
  },
  variants: {
    default: {},
    filled: {}
  }
};

export { Textarea };
